<template>
  <div>
    <h4 class="primary--text font-weight-medium">
      {{ $t('buttons:upload-specific', { specific: $t('common:media')}) }}
    </h4>

    <div class="image-container" >
      <v-img
        src="@/assets/preview_display.jpg"
        />

      <div class="image-preview">

        <div
          v-show="mediaType === 'IMAGE'"
          :class="{ 'top-image' : !fitScreen,  'fit-image': fitScreen}">
          <img
            v-show="mediaType === 'IMAGE'"
            :src="image.src"
            class="main-image"
            @click="$refs.imageViewer.showLarge()"
          />
        </div>

        <ImageViewer
          maxHeight=""
          maxWidth=""
          :showMainImage="false"
          :hideOverlay="true"
          ref="imageViewer"
        />
        <v-img
          v-show="mediaType === 'PDF'"
          src="@/assets/preview_pdf16x9.png"
          class="top-image"
          max-height=""
          max-width=""
        />

        <div
          v-show="mediaType === 'VIDEO'"
          class="fit-image">
          <video
            ref="videoContainer"
            v-if="mediaType === 'VIDEO' && videoLink.videoLoaded"
            controls
            @loadedmetadata="updateMediaLength"
            class="main-image"
          >
            <source
              :src="videoLink.src"/>
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>

    <v-file-input
      ref="uploadedFile"
      accept="image/*, application/pdf, video/*"
      :label="$t('buttons:upload-specific', { specific: $t('common:media')})"
      show-size
      v-model="file"
      :rules="[ruleMaxFileSize(100000, $t('utils:rules.filesize', {size : '100 MB'}))]"
      @change="uploadMedia"
    >
      <template v-slot:append>
        <v-fade-transition leave-absolute>
          <v-progress-circular
              v-show="isMediaLoading"
              size="24"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-fade-transition>
      </template>
    </v-file-input>
  </div>
</template>

<script>
import ImageViewer from '@/modules/core/components/DocumentViewer/ImageViewer';
import AdvertService from '@/modules/display/services/advert-service';
import {ruleMaxFileSize} from '@/modules/core/services/rules';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'MediaUserContainer',
  components: {
    ImageViewer
  },
  props: {
    advertId: String,
    mediaFile: Object,
    fitScreen: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      active_el: 2,
      mediaType: '',
      file: null,
      media: {},
      newVideoUploaded: false,
      image: {},
      isMediaLoading: false,
      videoLink: {
        src: ''
      }
    }
  },
  watch: {
    mediaFile: {
      deep: true,
      handler() {
        this.reset();
        if (!this.mediaFile || !this.mediaFile.name) return;
        this.setMediaType(this.mediaFile.type);
        this.media = Object.assign({}, this.mediaFile);
        this.showMedia(this.mediaFile);
      }
    }
  },
  methods: {
    ruleMaxFileSize,
    setMediaType(type) {
      this.mediaType = type !== null ? type : '';
      if (typeof type === 'undefined') {
        this.$emit('updateType', 'UNDEFINED');
        return;
      }

      type = type.toLocaleLowerCase();
      if (type.indexOf('image') !== -1) {
        this.mediaType = 'IMAGE';
      } else if(type.indexOf('video') !== -1) {
        this.mediaType = 'VIDEO';
      } else if (type.indexOf('pdf') !== -1) {
        this.mediaType = 'PDF';
      }

      this.$emit('updateType', this.mediaType);
    },
    reset() {
      this.media = {};
      this.setMediaType();
      this.$refs.imageViewer.reset();
    },
    uploadMedia() {
      if(!this.file) return;
      this.setMediaType();
      this.$refs.imageViewer.reset();
      this.isMediaLoading = true;

      AdvertService.uploadMedia(
        this.file,
        (response) => {
          this.isMediaLoading = false;
          this.setMediaType(this.file.type);
          this.media.type = this.file.type;
          this.media.name = this.file.name;

          if (this.mediaType === 'VIDEO') {
            this.newVideoUploaded = true;
          }

          this.showMedia({name: this.file.name, id: response.data.id, type: this.file.type});
          this.$emit('newMedia', response.data);
        },
        () => {
          this.isMediaLoading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:upload-failure', {name: this.$t('display/advert:edit.snackbar.picture')}));
        }
      )
    },
    showMedia(mediaFile) {
      let media = {
        name: mediaFile.name,
        src: '',
        videoLoaded: false
      };
      AdvertService.getFileAsDataUrl(
        mediaFile.id,
        this.mediaType === 'VIDEO',
        (result) => {
          media.src = result
          media.videoLoaded = true;
        }
      );

      if (this.mediaType === 'IMAGE') {
        this.$refs.imageViewer.initViewer(media);
        this.image = media;
      } else if (this.mediaType === 'VIDEO') {
        this.videoLink = media;
      }
    },
    updateMediaLength() {
      if (this.newVideoUploaded) {
        this.$emit('updateVideoLength', Math.floor(this.$refs.videoContainer.duration));
        this.newVideoUploaded = false;
      }
    }
  }
}
</script>

<style src="@/modules/display/views/advert/form/MediaUserContainer.scss" lang="scss"/>